module.exports = __webpack_public_path__ + "static/12-30c37cfcbc4d37384ed550010fceeac5.jpg";